<div class="interventions-section">
  @if (interventions().length > 0) {
    <mat-accordion multi class="interventions-section__accordion">
      @for (intervention of interventions(); track intervention.nnnInterventionDbRef) {
        <mat-expansion-panel class="intervention-panel">
          <mat-expansion-panel-header class="intervention-panel__header">
            <mat-panel-title class="intervention-panel__title">
              @if (interventie(intervention); as summary) {
                <span class="intervention-panel__badge">{{ summary.code }}</span>
                <span
                  class="intervention-panel__label"
                  [matTooltip]="summary.omschrijving"
                  matTooltipClass="card-tooltip">
                  {{ summary.omschrijving }}
                </span>
              } @else {
                <span class="intervention-panel__label">{{ intervention.nnnInterventionDbRef }}</span>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (intervention.activities.length > 0) {
            <ul class="intervention-panel__activities">
              @for (activity of intervention.activities; track activity.nnnActivityDbRef) {
                <li class="intervention-panel__activity">
                  {{ activityLabel(activity.nnnActivityDbRef) }}
                </li>
              }
            </ul>
          } @else {
            <p class="intervention-panel__no-activities">
              {{ 'epd.functions.careplan-nnn.interventions-section.no-activities' | translate | capitalize }}
            </p>
          }
          <app-nnn-notes-cell
            labelKey="epd.functions.careplan-nnn.interventions-section.notes"
            [value]="intervention.notes"
            [disabled]="!editable()"
            [showCounter]="editable()"
            (valueInput)="onNotesInput(intervention, $event)"
            (save)="saveNotes()"></app-nnn-notes-cell>
          @if (editable()) {
            <div class="intervention-panel__actions">
              <button
                mat-icon-button
                type="button"
                class="intervention-panel__action intervention-panel__action--info"
                (click)="openInfo()"
                matTooltip="{{ 'epd.functions.careplan-nnn.interventions-section.info-button' | translate | capitalize }}"
                matTooltipClass="card-tooltip">
                <mat-icon>info_outline</mat-icon>
              </button>
              <button
                mat-icon-button
                class="intervention-panel__action intervention-panel__action--edit"
                [disabled]="!interventie(intervention)"
                (click)="openEdit(intervention)"
                matTooltip="{{ 'general.actions.edit' | translate | capitalize }}"
                matTooltipClass="card-tooltip">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                class="intervention-panel__action intervention-panel__action--delete"
                (click)="remove(intervention)"
                matTooltip="{{ 'general.actions.delete' | translate | capitalize }}"
                matTooltipClass="card-tooltip">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
  @if (editable()) {
    <button mat-button color="primary" class="interventions-section__add" (click)="openAdd()">
      <mat-icon>add</mat-icon>
      {{ 'epd.functions.careplan-nnn.interventions-section.add' | translate | capitalize }}
    </button>
  }
  @if (editable()) {
    <div class="interventions-section__save-state">
      @if (saveState() === 'saving') {
        <span>{{ 'general.actions.saving' | translate }}</span>
      } @else if (saveState() === 'saved') {
        <span class="interventions-section__save-state--saved">{{ 'general.words.saved' | translate }}</span>
      }
    </div>
  }
</div>
